/* ================================================== */
/* PLUGINS → slidesjs
/* ================================================== */

$(document).ready(function() {

	$('.slider').slidesjs({
		play: {
			active  : true,
			interval: 4000,
			auto    : true
		},
		effect: {
			slide: {
				speed: 1000
			}
		}
	});

});